// @ts-nocheck
export const capacity = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500];
